/**
 * ParkingProposalsLegend — легенда слоя «Предложения по парковкам» (DA-15433)
 *
 * Слой состоит из двух половин, которые гасятся независимо:
 *   — полигоны спроса: выпуклые оболочки кластеров алертов завершения парковки,
 *     раскрашенные по месту кластера в спросе ВНУТРИ своего города (абсолютное число
 *     людей в Москве и во Владимире несопоставимо);
 *   — точки парковок: парковка конкурента в 50 м от оболочки, ближайшая к центру масс
 *     кластера, и круг её радиуса покрытия 30 м. Точка и круг — это одно предложение,
 *     поэтому у них общий переключатель.
 *
 * Точка находится не у каждого кластера: у большинства оболочек предложить нечего,
 * и они остаются на карте одними полигонами.
 */

import { i18n } from '@lingui/core';
import { t } from '@lingui/macro';
import classnames from 'classnames';
import { connect } from 'react-redux';
import React from 'react';
import {
    onToggleParkingProposalsHulls,
    onToggleParkingProposalsPoints,
} from '../../../ac/onChangeMapFilters';
import { LegendRenderer } from '../../LegendRenderer';
import { PARKING_PROPOSALS_LEGEND } from '../../../constants/legends';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import styles from '../FilterSidebar.module.css';

const Toggle = ({ label, checked, onChange }) => (
    <div className={styles.errGroupHeader}>
        <span>{label}</span>
        <label className={styles.switch}>
            <input
                type='checkbox'
                checked={checked}
                onChange={onChange}
            />
            <span className={classnames(styles.sliderRound, styles.slider)} />
        </label>
    </div>
);
const ParkingProposalsLegendComponent = ({
    mapFilters,
    onToggleParkingProposalsHulls: onToggleHulls,
    onToggleParkingProposalsPoints: onTogglePoints,
}) => (
    <div>
        <Toggle
            label={i18n._({ id: 'Полигоны спроса', message: 'Полигоны спроса' })}
            checked={mapFilters.parkingProposalsShowHulls}
            onChange={onToggleHulls}
        />
        <div className={styles.errGroupItems}>
            <LegendRenderer config={PARKING_PROPOSALS_LEGEND} />
        </div>
        <Toggle
            label={i18n._({ id: 'Точки парковок', message: 'Точки парковок' })}
            checked={mapFilters.parkingProposalsShowPoints}
            onChange={onTogglePoints}
        />
    </div>
);
const mapStateToProps = ({ mapFilters }) => ({ mapFilters });
const ConnectedComponent = connect(mapStateToProps, {
    onToggleParkingProposalsHulls,
    onToggleParkingProposalsPoints,
})(ParkingProposalsLegendComponent);

export const ParkingProposalsLegend = withDisplayedLayersCheck(
    ConnectedComponent,
    t`Предложения по парковкам`
);
